import MuiTableHead from "@mui/material/TableHead";

export default function TableHead(props) {
  return <MuiTableHead {...props} />;
}
